import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import PROPERTIES from '../../../api/ressources/SellerApp/properties';
import RADAR_LEADS from '../../../api/ressources/App/radarLeads';

export const getRadarProperties = createAsyncThunk(
  'radar/getRadarProperties',
  async (params) => {
    const response = await PROPERTIES.getRadarProperties(params);
    return response.data;
  }
);

export const getRadarLeadsCount = createAsyncThunk(
  'radar/getRadarLeadsCount',
  async () => {
    const response = await RADAR_LEADS.getRadarLeadsCount();
    return response.data;
  }
);

const zoomLevels = {
  250: 15,
  500: 14,
  1000: 13
};

const getURLParams = () => {  
  const params = new URLSearchParams(window.location.search);
  return {
    lat: parseFloat(params.get('lat')),
    lng: parseFloat(params.get('lng')),
    radius: parseInt(params.get('radius'))
  };
};

const urlParams = getURLParams();

const initialState = {
  addressObj: {},
  map: null,
  coordinates: urlParams.lat && urlParams.lng 
    ? [parseFloat(urlParams.lng), parseFloat(urlParams.lat)]
    : [2.35, 48.85],
  zoom: urlParams.radius ? zoomLevels[[250, 500, 1000].includes(urlParams.radius) ? urlParams.radius : 250] : 6,
  radius: (urlParams.radius && [250, 500, 1000].includes(urlParams.radius)) ? urlParams.radius : null,
  radarVisibility: true,
  displayRecenterPin: false,
  properties: [],
  hoveredPropertyId: null,
  modalPropertyId: null,
  isSearching: false,
  loginModalOpen: false,
  phoneNumberModalOpen: false,
  noResultsModalOpen: false,
  userProject: null
};

export const radarSlice = createSlice({
  name: 'radar',
  initialState,
  reducers: {
    updateMap(state, { payload }) {
      state.map = payload;
    },
    updateAddressObj(state, { payload }) {
      state.addressObj = payload;      
      if (payload.lng) {
        if (!state.radius) state.radius = 250;
        state.zoom = zoomLevels[state.radius];
        state.coordinates = [payload.lng, payload.lat];
      }
    },
    updateMapCenter(state, { payload }) {
      const { coordinates, radius } = payload;
      
      if (coordinates) {
        state.coordinates = coordinates;
      }
      
      if (radius) {
        state.radius = radius;
        state.zoom = zoomLevels[radius];
      }
    },
    searchByPin(state) {
      if (!state.radius) state.radius = 250;
      state.zoom = zoomLevels[state.radius];
      state.displayRecenterPin = false;
      state.radarVisibility = true;
    },
    updateRadarVisibility(state, { payload }) {
      state.radarVisibility = payload;
    },
    updateDisplayRecenterPin(state, { payload }) {
      state.displayRecenterPin = payload;
    },
    updateHoveredPropertyId(state, { payload }) {
      state.hoveredPropertyId = payload;
    },
    updateModalPropertyId(state, { payload }) {
      state.hoveredPropertyId = null;
      state.modalPropertyId = payload;
    },
    updateIsSearching(state, { payload }) {
      state.isSearching = payload;
    },
    updateLoginModalOpen(state, { payload }) {
      state.loginModalOpen = payload;
    },
    updatePhoneNumberModalOpen(state, { payload }) {
      state.phoneNumberModalOpen = payload;
    },
    updateNoResultsModalOpen(state, { payload }) {
      state.noResultsModalOpen = payload;
    },
    updateUserProject(state, { payload }) {
      state.userProject = payload;
    },
    updateRadarLeadsCount(state, { payload }) {
      state.radarLeadsCount = payload;
    },
    resetRadar(state) {
      return {
        ...initialState,
        map: state.map,
        addressObj: state.addressObj
      };
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getRadarProperties.pending, (state) => {
      state.isSearching = true;
      state.properties = [];
    });
    builder.addCase(getRadarProperties.fulfilled, (state, { payload }) => {
      if (payload.total === 0) {
        state.isSearching = false;
        state.noResultsModalOpen = true;
      } else {
        state.properties = payload.results;
      }
    });
    builder.addCase(getRadarProperties.rejected, (state) => {
      state.isSearching = false;
      state.properties = [];
    });
    builder.addCase(getRadarLeadsCount.fulfilled, (state, { payload }) => {
      state.radarLeadsCount = payload.radar_leads_count
    });
  },
});

export const { 
  updateMap, 
  updateAddressObj, 
  updateMapCenter,
  searchByPin, 
  updateRadarVisibility, 
  updateDisplayRecenterPin, 
  updateHoveredPropertyId, 
  updateModalPropertyId, 
  updateIsSearching, 
  updateLoginModalOpen,
  updatePhoneNumberModalOpen, 
  updateNoResultsModalOpen, 
  updateUserProject,
  updateRadarLeadsCount,
  resetRadar
} = radarSlice.actions;

export default radarSlice.reducer;
